/**
 * External dependencies
 */
import React from 'react';
import { Provider } from 'react-redux';
import { noop } from 'lodash';
import page from 'page';
import { TowerProvider } from '@towersystems/towersystems-design-system';
import * as t from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import { setSection as setSectionAction } from 'state/ui/actions';
import { isUserLoggedIn } from 'state/current-user/selectors';
import Layout from 'layout';
import LoggedOutLayout from 'layout/logged-out';
import { hydrate, redirectLoggedOut } from './utils';

export { render, hydrate, redirectLoggedIn } from './utils';

export function setSection(section) {
    return (context, next = noop) => {
        context.store.dispatch(setSectionAction(section));
    };
}

export function makeLayoutMiddleware(LayoutComponent) {
    return (context, next) => {
        const { store, primary, secondary } = context;
        context.layout = (
            <TowerProvider>
                <LayoutComponent
                    store={store}
                    primary={primary}
                    secondary={secondary}
                    redirectUri={context.originalUrl}
                />
            </TowerProvider>
        );
        next();
    };
}

export const ReduxWrappedLayout = ({ store, primary, secondary, redirectUri }) => {
    const state = store.getState();
    const userLoggedIn = isUserLoggedIn(state);

    const layout = userLoggedIn ? (
        <Layout primary={primary} secondary={secondary} />
    ) : (
        <LoggedOutLayout primary={primary} secondary={secondary} />
    );

    return <Provider store={store}>{layout}</Provider>;
};

export const makeLayout = makeLayoutMiddleware(ReduxWrappedLayout);

export function clientRouter(route, ...middlewares) {
    page(route, ...middlewares);
}
